import { render, staticRenderFns } from "./iam-view-toolbar.vue?vue&type=template&id=6e0dd1a0&scoped=true&"
import script from "./iam-view-toolbar.vue?vue&type=script&lang=js&"
export * from "./iam-view-toolbar.vue?vue&type=script&lang=js&"
import style0 from "./iam-view-toolbar.vue?vue&type=style&index=0&id=6e0dd1a0&lang=scss&scoped=true&"
import style1 from "./iam-view-toolbar.vue?vue&type=style&index=1&id=6e0dd1a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e0dd1a0",
  null
  
)

export default component.exports
import {QBtn} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QBtn})
